import { Outlet } from 'react-router';

/**
 * Padded outlet for routes whose pages don't own their own padding.
 *
 * Carries the shared `page-layout` frame that `DashboardLayout`'s deleted
 * `variant="padded"` shortcut used to provide. Used at route-element level
 * (not as a page wrapper) so the frame is shared by all child routes that
 * opted into it (currently the `/knowledge-hub` and `/trackers` children).
 *
 * Pages that own their own frame at the page root (e.g. `Projects.tsx`) do
 * NOT need this — they sit directly under the unified `DashboardLayout`.
 *
 * Lives in its OWN file (not co-located in `AppRoutes.tsx`) so the
 * route module remains a pure exporter of the `router` factory —
 * Vite/React Refresh can hot-reload component files cleanly.
 */
export const PaddedOutlet = () => (
  <div data-testid="dashboard-layout-padded" className="page-layout">
    <Outlet />
  </div>
);
